import { render, staticRenderFns } from "./InclusiveGroupItemConfig.vue?vue&type=template&id=865b326c&scoped=true"
import script from "./InclusiveGroupItemConfig.vue?vue&type=script&lang=js"
export * from "./InclusiveGroupItemConfig.vue?vue&type=script&lang=js"
import style0 from "./InclusiveGroupItemConfig.vue?vue&type=style&index=0&id=865b326c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865b326c",
  null
  
)

export default component.exports